import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { PropsWithChildren } from "react";

import type { AppEnvironment } from "../config/environment.js";
import { EnvironmentProvider } from "../config/environment-context.js";
import { ApiProvider } from "../shared/api/api-context.js";
import { AuthProvider } from "../shared/auth/auth-context.js";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: (failureCount) => failureCount < 2,
      staleTime: 15_000,
    },
  },
});

interface AppProvidersProps extends PropsWithChildren {
  readonly environment: AppEnvironment;
}

export function AppProviders({ children, environment }: AppProvidersProps) {
  return (
    <EnvironmentProvider environment={environment}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider environment={environment}>
          <ApiProvider baseUrl={environment.VITE_API_BASE_URL}>{children}</ApiProvider>
        </AuthProvider>
      </QueryClientProvider>
    </EnvironmentProvider>
  );
}
